import React, { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import MUIButton from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Button from "../Button";
import SC from "./style";
import Applogo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";

const Navbar = (props) => {
  const { logo, pages, onPageSelect } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleCloseMenu = (page) => {
    setMobileOpen(false);
    if (onPageSelect) onPageSelect(page);
  };

  const handleClick = () => {
    setMobileOpen(false);

    // onPageSelect("welcomeback");
    navigate("/welcome");
  };

  return (
    <SC.StyledAppBar>
      <SC.StyledContainer>
        <SC.StyledToolbar>
          {/* Logo */}
          {/* <Typography component="a" sx={SC.logoStyle} href="/">
            {logo}
            <span style={SC.trademark}>tm</span>
          </Typography> */}
          <img
            src={logo}
            style={{
              width: "200px",
              height: "38px",
              objectFit: "contain",
              marginRight: "100px",
            }}
            alt="app logo"
          />

          {/* Mobile Menu Icon */}
          <Box sx={{ display: { xs: "flex", md: "none", color: "white" } }}>
            <IconButton
              size="large"
              onClick={handleDrawerToggle}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </Box>

          {/* Desktop Navigation */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 3 }}>
            {pages.map((page) => (
              <MUIButton
                key={page}
                onClick={() => handleCloseMenu(page)}
                sx={SC.navButton}
              >
                {page}
              </MUIButton>
            ))}
          </Box>

          {/* Buttons (Visible in Desktop Only) */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: "10px" }}>
            {/* <Button
              caption="Sign in"
              sx={SC.signInButton}
              onClick={() =>
                (window.location.href = "https://prakalpa.innologic.co.in/")
              }
            /> */}
            <Button
              caption="Try me"
              color="white"
              sx={SC.trialButton}
              onClick={() => handleClick()}
            />
          </Box>
        </SC.StyledToolbar>
      </SC.StyledContainer>

      {/* Mobile Menu Drawer */}
      <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
        <Box
          sx={{ width: 200, display: "flex", flexDirection: "column", p: 2 }}
        >
          <Typography component="a" href="#" sx={SC.logoStyle}>
            {logo}
            <span style={SC.trademark}>tm</span>
          </Typography>
          {/* <img
            src={Applogo}
            style={{
              width: "190px",
              height: "40px",
              objectFit: "contain",
              marginRight: "100px",
            }}
            alt="app logo"
          /> */}

          {pages.map((page) => (
            <MenuItem key={page} onClick={() => handleCloseMenu(page)}>
              <Typography textAlign="center" sx={{ color: "black" }}>
                {page}
              </Typography>
            </MenuItem>
          ))}
          {/* Mobile Buttons */}
          <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 1 }}>
            {/* <Button
              caption="Sign in"
              sx={SC.signInButton}
              onClick={() =>
                (window.location.href = "https://prakalpa.innologic.co.in/")
              }
            /> */}
            <Button
              caption="Try me"
              color="white"
              sx={SC.trialButton}
              onClick={() => handleClick()}
            />
          </Box>
        </Box>
      </Drawer>
    </SC.StyledAppBar>
  );
};

export default Navbar;
